'use strict';

/**
 * Component for the prices
 *
 * @category   View
 * @module     collection.edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var LayoutView = require('base/Colido.LayoutView');

var template = require('../../templates/components/field-group.hbs');

var GroupComponent = LayoutView.extend({
    template: template,

    className: function() {
        var field = this.getOption('field');

        return 'form-component component-' + _.camelToHyphen(field.type);
    },

    viewData: {
        field: function() {
            return this.getOption('field');
        },

        isGroupChild: function() {
            return this.getOption('isGroupChild');
        },
    },

    onRender: function() {
        var field = this.getOption('field');
        var baseView = this.getOption('baseView');
        var sourceFields = _.difference(field.sourceFields, field.disabledSourceFields);

        var subRegions = {};
        _.each(sourceFields, function(sourceFieldName){
            subRegions['field' + _.ucfirst(sourceFieldName) + 'Region'] = '.field-' + _.camelToHyphen(sourceFieldName) + '-region';
        })

        this.addRegions(subRegions);

        _.each(sourceFields, function(sourceFieldName){
            var sourceField = this.model.collection.catalog.getEditField(sourceFieldName);

            var componentView = baseView.getComponentView(sourceField, {isGroupChild: true});
            if (componentView) {
                this['field' + _.ucfirst(sourceFieldName) + 'Region'].show(componentView);
            }
        }.bind(this));
    },

    /**
     * Resets the states and data of the component
     */
    reset: function() {
        _.each(this.getRegions(), function(region){
            if (region.hasView() && region.currentView.reset) {
                region.currentView.reset();
            }
        });
    },

    onShow: function() {
        this.reset();
    },

    getData: function() {
        var data = {};

        _.each(this.getRegions(), function(region){
            if (region.hasView()) {
                _.extend(data, region.currentView.getData());
            }
        });

        return data;
    },
});

module.exports = GroupComponent;